<template>
  <component :style="getStyleObject()" :is="componentLoader('ImageText')">
    <!--<img slot="image" class="img-fluid rounded mb-6 mb-md-0" :src="data.image+`w=400&h=600&fit=crop`" alt="">-->
    <template slot="image">
      <!--<svgfremcast :icon="getSvg" :original="true"  color="_ _ _ _ _ _ red _ _"></svgfremcast>-->
    </template>
    <span slot="title">{{ data.title.data }}</span>
    <span slot="text" v-html="data.text.data"></span>
  </component>
</template>
<script>
  import settings from '@fremcast/section/mixins/section';
  //import '@fremcast/template/compiled-icons';
  export default {
    data() {
      return {
        svg: {
          1: 'youtube_tutorial',
          2: 'drone',
          3: 'wireframe',
          4: 'online_video'
        }
      };
    },
    props: [
      'data'
    ],
    mixins: [
      settings
    ],
    computed: {
      getSvg() {
        return this.svg[_.random(1,4)];
      }
    },
    methods: {
      getStyleObject() {
        const style = this.fetchSettings.style;
        return {
          backgroundColor: style.backgroundColor,
          color: style.fontColor,
          "padding-left": style.paddingTop + 'px',
          "padding-top": style.paddingTop + 'px',
          "padding-right": style.paddingTop + 'px',
          "padding-bottom": style.paddingBottom + 'px'
        }
      }
    }
  }
</script>